import { render, staticRenderFns } from "./featureList.vue?vue&type=template&id=6377f8d9&scoped=true&lang=pug&"
import script from "./featureList.vue?vue&type=script&lang=js&"
export * from "./featureList.vue?vue&type=script&lang=js&"
import style0 from "./featureList.vue?vue&type=style&index=0&id=6377f8d9&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6377f8d9",
  null
  
)

export default component.exports